<template>
  <a-dropdown :trigger="['click']" v-model:visible="visible" :getPopupContainer="getContainer">
    <template #overlay>
      <a-menu>
        <a-menu-item @click="handleSelect('task')"> 任务 </a-menu-item>
        <a-menu-divider />
        <a-menu-item key="2" class="no-hover">
          <a-input
            v-model:value="diyValue"
            @click.stop="(e) => e.target.focus()"
            placeholder="请输入"
            style="width: 150px"
          />
          <a-space style="margin-top: 10px; display: flex; justify-content: flex-end">
            <a-button @click="cancel" size="small">取消</a-button>
            <a-button type="primary" @click="ok" size="small">确定</a-button>
          </a-space>
        </a-menu-item>
      </a-menu>
    </template>
    <a-input v-model:value="selectValue" readonly placeholder="请选择">
      <template #suffix>
        <DownOutlined style="color: #c8c8c8" @click="visible = true" />
      </template>
    </a-input>
  </a-dropdown>
</template>

<script lang="ts">
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { message } from "ant-design-vue";
import { defineComponent, reactive, ref, toRefs, watch } from "vue";
import { DownOutlined } from "@ant-design/icons-vue";
export default defineComponent({
  name: "WorkPlanUnitSelect",
  isGlobal: true,
  components: {
    DownOutlined,
    VNodes: (_, { attrs }) => {
      return attrs.vnodes;
    },
  },
  props: {
    value: {
      type: String,
    },
    count: {
      type: Number,
    },
  },
  emits: ["update:value", "update:count"],
  setup(props, { emit }) {
    const items = ref([
      {
        label: "任务",
        value: "task",
      },
    ]);
    const diyValue = ref("");
    const visible = ref(false);

    const selectValue = ref("");
    const handleChange = (v) => {
      emit("update:value", v);
    };
    const handleSelect = (value) => {
      if (value) {
        selectValue.value = "任务";
        handleChange("task");
        emit("update:count", 1);
      } else {
      }
    };
    const cancel = () => {
      diyValue.value = "";
      visible.value = false;
    };
    const ok = () => {
      selectValue.value = diyValue.value;
      emit("update:value", diyValue.value);
      visible.value = false;
    };
    watch(
      () => props.value,
      () => {
        if (props.value == "task") {
          selectValue.value = "任务";
        } else {
          selectValue.value = props.value || "";
        }
      },
      {
        immediate: true,
      }
    );
    onMountedOrActivated(async () => {});
    const getContainer = () => {
      return document.body;
    };
    return {
      //   loading,
      diyValue,
      items,
      handleChange,
      selectValue,
      handleSelect,
      getContainer,
      cancel,
      ok,
      visible,
    };
  },
});
</script>
<style>
.no-hover:hover {
  background: #fff;
}
</style>
